export default [
    {
        path: '/L4k1iaQ3nlCa',
        children: [
            {
                path: '3dbzxqVMnc',
                name: 'examStudents',
                meta: {
                    title: ' Examination Students',
                    authRequired: true,
                    acc: ['y91980'],
                },
                component: () => import('../views/exam-cards/list.vue'),
            },
            {
                path: 'U5vqXSoXod/:cr?',
                name: 'viewExamCard',
                meta: {
                    title: 'View Examination Card',
                    authRequired: true,
                    acc: ['y32008'],
                },
                component: () => import('../views/exam-cards/view.vue'),
            },
            
        ]
    }
]